define('modules/page_listing/views/copy_to_account_popup',['require','exports','module','common/views/modal_view','services/auth/info','ldsh!../templates/copy_to_account_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view"),
      AuthInfo = require("services/auth/info"),
      authInfo = new AuthInfo();

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/copy_to_account_popup"),
    triggers: {
      "click .js-cancel": "cancel"
    },
    events: {
      "click .js-ok": "onCopy",
    },
    helpers: function() {
      return {
        companyId: authInfo.getCompanyId(),
        companies: authInfo.getCompanies()
      };
    },
    onCopy: function(e) {
      e.preventDefault();
      var accountId = this.$(".js-account-selector").val();
      this.trigger("ok", accountId);
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

  _.extend(module.exports, {
    show: function(page) {
      var popup = new module.exports({model: page}),
          defer = $.Deferred();
      popup.on("ok", _.bind(defer.resolve, defer));
      popup.on("cancel", _.bind(defer.reject, defer));
      defer.always(_.bind(popup.hide, popup));
      return defer.promise();
    }
  });
});


